import { render, staticRenderFns } from "./DataSourcesItems.vue?vue&type=template&id=62de05a4&"
import script from "./DataSourcesItems.vue?vue&type=script&lang=js&"
export * from "./DataSourcesItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports